<template>
  <div class="nuxt-error">
    <component :is="errorPage" :error="error" />
  </div>
</template>

<script>
  const error404 = () => import('~/components/error/404.vue')
  const error500 = () => import('~/components/error/500.vue')
  export default {
    name: 'nuxt-error',
    layout: 'default',
    props: {
      error: {
        type: Object,
        default: () => {}
      }
    },
    computed: {
      errorPage () {
        if (this.error.statusCode === 404) {
          return error404
        }
        return error500
      }
    }
  }
</script>